const TRACE_ENUM = {
  // pv
  VIEW: 'view',
  ORDER: 'fetchOrder',
  SMSCODE: 'smsCode',
  UNICOM_ORDER: 'unicomOrder',
  SUBMIT: 'submitOrder',
  // 必得奖品领取
  AWARD: 'fetchAward',
  // 抽奖
  LOT_AWARD: 'fetchLotAward',
  WEB_LOADED: 'webLoaded',
  IMG_LOADED: 'imgLoaded',

  CLOSE: 'leave',

  START_FREE_LOTTERY: 'startFreeLottery',
  SHOW_FREE_LOTTERY_DIALOG: 'showFreeLotteryDialog',
  CLICK_FREE_LOTTERY_BUTTON: 'clickFreeLotteryButton',
};

export default TRACE_ENUM;
